import(/* webpackMode: "eager" */ "/tmp/8de698b5c6a30cb/app/[locale]/error.tsx");
